<div class="container text-center p-5" *ngIf="isBrowser">
    <h1 class="">404 Not Found</h1>
    <p class="">The page you've requested cannot be found. Please ensure the spelling of the URL is correct or try again later.</p>
</div>
